import { useEffect, useState } from "react";

/**
 * The value, held back until it has stopped changing for `delayMs`.
 *
 * Typing into a search box changes the value on every keystroke; feeding that straight into a
 * query key sends one request per character. Debouncing collapses a burst of keystrokes into the
 * single request the user actually meant.
 */
export const useDebouncedValue = (value, delayMs) => {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return settled;
};
